export default {
  'meta': {
    'langName': 'SLOVENIAN',
    'lang': 'Slovenščina'
  },
  'title': 'ODPOKLIC IZDELKA NASTAVLJIV SAMOSTOJEČI KOŠ S STOJALOM B900 BOX NBA TARMAK',
  'description': 'Pozdravljeni.\n\nPred kratkim ste kupili košarkarski koš Tarmak B900 BOX NBA. Za nakup se vam zahvaljujemo.\n\nMed opravljanjem preizkusov kakovosti izdelka je DECATHLONOVA ekipa za košarko odkrila morebitno tveganje: drog lahko pade, če je ročica za nastavljanje višine odstranjena in se izdelek nato premakne ali uporablja.\n\nVljudno vas prosimo, da odgovorite na nekaj vprašanj. Tako vam bomo lahko zagotovili rešitev in popolno varnost vašega izdelka.\n\nOpravičujemo se za povzročene nevšečnosti in zahvaljujemo za izkazano zaupanje.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Najprej vas prosimo, da potrdite svoj e-poštni naslov in državo, kjer bivate.'
  },
  'fields': {
    'country': 'Država',
    'address': 'E-poštni naslov',
    'email': 'E-poštni naslov',
    'phonePrefix': 'Klicna številka',
    'phone': 'Telefonska številka',
    'validations': {
      'phoneOrEmail': 'Prosimo, navedite vsaj en e-poštni naslov ali telefonsko številko.',
      'email': 'Prosimo, vnesite veljaven e-poštni naslov',
      'phone': 'Prosimo, vnesite veljavno telefonsko številko'
    },
    'firstName': 'Priimek',
    'lastName': 'Ime',
    'deliveryAddress': 'Naslov za pošiljanje paketa',
    'additionalAddress': 'Dodatni podatki o naslovu',
    'city': 'Kraj',
    'zip': 'Poštna številka',
    'choose': 'Izberi',
    'required': 'Polje je obvezno'
  },
  'ownerCheck': {
    'title': 'Ali imate še vedno enega ali več košev Tarmak B900 BOX NBA?'
  },
  'yes': 'DA',
  'no': 'NE',
  'ownerChanged': {
    'title': 'Ali imate kontaktne podatke trenutnih lastnikov?',
    'confirmation': 'Spoštovani,\n\nzahvaljujemo se vam za sodelovanje v vprašalniku za zagotavljanje kakovosti.\n\nOpravičujemo se za povzročene nevšečnosti in zahvaljujemo za izkazano zaupanje.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Prosimo, navedite koliko košev imate; ločeno po vrsti ročice za nastavljanje višine',
    'descriptionRed': 'Koš z odstranljivo, rdečo ročico',
    'descriptionBlack': 'Koš z vgrajeno, črno ročico',
    'quantity': 'Število',
    'notConcerned': 'Spoštovani,\n\nzahvaljujemo se vam za sodelovanje v vprašalniku za zagotavljanje kakovosti.\n\nVaš koš Tarmak B900 BOX NBA je popolnoma varen za uporabo in ni del tega odpoklica.\n\nOpravičujemo se za povzročene nevšečnosti in zahvaljujemo za izkazano zaupanje.\n\nDECATHLON',
    'concernedProductQuantity': 'Število neskladnih izdelkov:',
    'concernedProductLabel': 'Neskladni izdelki:',
    'confirmation': 'Hvala, da ste izpolnili obrazec. Vaša zahteva je uspešno zabeležena.\n\nKmalu vam bomo poslali številko za sledenje paketu, v katerem bo komplet za popravilo (FandiWeb za evropske države, X za neevropske države).\n\nLep dan,\n\nDECATHLON'
  },
  'repair': {
    'title': 'Popravilo z vašo pomočjo',
    'description': 'Odkrili smo potencialno tveganje padca pokončnega droga, če je ročica za nastavljanje višine odstranjena in se koš uporablja. To velja za določene košarkarske koše TARMAK B900 BOX NBA, referenčna št.: 4239136.\nGlede na vaše odgovore sklepamo, da pri vašem izdelku obstaja takšno tveganje.\n\nZato vas prosimo, da ga takoj prenehate uporabljati, mi pa vam bomo zagotovili vse potrebno za popravilo ročice in zagotavljanje popolne varnosti izdelka. To popravilo ne bo zahtevalo nobenega posebnega znanja - vse potrebno je podrobno obrazloženo v spodnjem posnetku in navodilih.\n\n',
    'videoLink': 'Povezava do posnetka',
    'docLink': 'Povezava do navodil',
    'callToAction': 'Kliknite tukaj za naročilo brezplačnega kompleta za popravilo',
    'warranty': 'Celoten postopek krije naša 5-letna garancija'
  },
  'repairRequest': {
    'title': 'Prosimo, vnesite naslednje informacije in prejeli boste brezplačni komplet za popravilo na izbrani naslov:'
  },
  'form': {
    'submit': 'Naprej'
  },
  'status': 'Translation validated by COUNTRY'
} as const
